/**
 * Product Template Data - Interactive JS
 * Handles: Scroll animations, Gallery slider, Lightbox, Review Lightbox, FAQ toggle
 */

(function () {
  'use strict';

  /* ─── Scroll Reveal (IntersectionObserver) ─── */
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e, i) {
      if (e.isIntersecting) setTimeout(function () { e.target.classList.add('visible'); }, i * 60);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
  document.querySelectorAll('.fade-up, .img-reveal, .line-grow').forEach(function (el) { obs.observe(el); });

  /* ─── Gallery Slider ─── */
  var currentSlide = 0;
  var track = document.getElementById('galleryTrack');
  var slides = document.querySelectorAll('.gallery-slide img');
  var totalSlides = (typeof wp_total_images !== 'undefined' && wp_total_images > 0)
    ? wp_total_images
    : (window.product_data && window.product_data.images ? window.product_data.images.length : slides.length);
  var dots = document.querySelectorAll('.gallery-dot');

  function updateSlider() {
    if (!track) return;
    track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    dots.forEach(function (dot, i) {
      dot.classList.toggle('active', i === currentSlide);
      dot.style.background = i === currentSlide ? '#0a0a0a' : '#d4d4d8';
      dot.style.transform = i === currentSlide ? 'scale(1.2)' : 'scale(1)';
    });
  }

  window.nextSlide = function () { currentSlide = (currentSlide + 1) % totalSlides; updateSlider(); };
  window.prevSlide = function () { currentSlide = (currentSlide - 1 + totalSlides) % totalSlides; updateSlider(); };
  window.goToSlide = function (index) { currentSlide = index; updateSlider(); };

  /* Touch swipe for gallery */
  var touchStartX = 0;
  var slider = document.getElementById('galleryS');
  if (slider) {
    slider.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) { diff > 0 ? window.nextSlide() : window.prevSlide(); }
    }, { passive: true });
  }

  /* ─── Product Image Lightbox ─── */
  var lightboxIndex = 0;
  var lightbox = document.getElementById('lightbox');
  var lightboxImg = document.getElementById('lightboxImg');
  var lightboxCounter = document.getElementById('lightboxCounter');
  var lbDots = document.querySelectorAll('.lb-dot');

  function updateLightbox() {
    if (!lightboxImg || !slides[lightboxIndex]) return;
    var imgSrc = slides[lightboxIndex].src;
    lightboxImg.src = imgSrc.replace(/w=\d+/, 'w=800').replace(/h=\d+/, 'h=800');
    if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + totalSlides;
    lbDots.forEach(function (dot, i) {
      dot.classList.toggle('active', i === lightboxIndex);
      dot.style.background = i === lightboxIndex ? '#ffffff' : 'rgba(255,255,255,0.4)';
      dot.style.transform = i === lightboxIndex ? 'scale(1.2)' : 'scale(1)';
    });
  }

  window.openLightbox = function (index) {
    if (!lightbox) return;
    lightboxIndex = index;
    lightbox.classList.remove('hidden');
    setTimeout(function () { lightbox.classList.add('open'); }, 10);
    updateLightbox();
    document.body.style.overflow = 'hidden';
  };

  window.doCloseLightbox = function () {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    setTimeout(function () { lightbox.classList.add('hidden'); document.body.style.overflow = ''; }, 300);
  };

  window.closeLightbox = function (e) {
    if (e && e.target.closest('.lightbox-content')) return;
    window.doCloseLightbox();
  };

  window.lightboxNext = function (e) {
    if (e) e.stopPropagation();
    lightboxIndex = (lightboxIndex + 1) % totalSlides;
    updateLightbox();
  };

  window.lightboxPrev = function (e) {
    if (e) e.stopPropagation();
    lightboxIndex = (lightboxIndex - 1 + totalSlides) % totalSlides;
    updateLightbox();
  };

  window.lightboxGoTo = function (index, e) {
    if (e) e.stopPropagation();
    lightboxIndex = index;
    updateLightbox();
  };

  /* Touch swipe for lightbox */
  var lbTouchStartX = 0, lbTouchStartY = 0;
  var lbContent = document.querySelector('.lightbox-content');
  if (lbContent) {
    lbContent.addEventListener('touchstart', function (e) {
      lbTouchStartX = e.changedTouches[0].screenX;
      lbTouchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    lbContent.addEventListener('touchend', function (e) {
      var diffX = lbTouchStartX - e.changedTouches[0].screenX;
      var diffY = lbTouchStartY - e.changedTouches[0].screenY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        diffX > 0 ? window.lightboxNext() : window.lightboxPrev();
      } else if (diffY > 80) {
        window.doCloseLightbox();
      }
    }, { passive: true });
  }

  /* ─── Review Lightbox ─── */
  var reviewLightbox = document.getElementById('reviewLightbox');
  var reviewLightboxImg = document.getElementById('reviewLightboxImg');
  var reviewLightboxUser = document.getElementById('reviewLightboxUser');
  var reviewLightboxStars = document.getElementById('reviewLightboxStars');
  var reviewLightboxCounter = document.getElementById('reviewLightboxCounter');
  var reviewImages = document.querySelectorAll('.review-img');
  var currentReviewIndex = 0;

  function updateReviewLightbox() {
    if (!reviewImages[currentReviewIndex]) return;
    var el = reviewImages[currentReviewIndex];
    var img = el.querySelector('img');
    var user = el.dataset.user;
    var rating = parseInt(el.dataset.rating);
    if (reviewLightboxImg && img) {
      reviewLightboxImg.src = img.src.replace(/w=\d+/, 'w=600').replace(/h=\d+/, 'h=600');
    }
    if (reviewLightboxUser) reviewLightboxUser.textContent = user;
    if (reviewLightboxStars) {
      reviewLightboxStars.innerHTML = Array(5).fill(0).map(function (_, i) {
        return '<i class="fas fa-star text-sm ' + (i < rating ? 'text-amber-400' : 'text-silver-600') + '"></i>';
      }).join('');
    }
    if (reviewLightboxCounter) reviewLightboxCounter.textContent = (currentReviewIndex + 1) + ' / ' + reviewImages.length;
  }

  window.openReviewLightbox = function (el) {
    if (!reviewLightbox) return;
    currentReviewIndex = Array.from(reviewImages).indexOf(el);
    updateReviewLightbox();
    reviewLightbox.classList.remove('hidden');
    setTimeout(function () { reviewLightbox.classList.add('open'); }, 10);
    document.body.style.overflow = 'hidden';
  };

  window.nextReviewLightbox = function (e) {
    if (e) e.stopPropagation();
    currentReviewIndex = (currentReviewIndex + 1) % reviewImages.length;
    updateReviewLightbox();
  };

  window.prevReviewLightbox = function (e) {
    if (e) e.stopPropagation();
    currentReviewIndex = (currentReviewIndex - 1 + reviewImages.length) % reviewImages.length;
    updateReviewLightbox();
  };

  window.doCloseReviewLightbox = function () {
    if (!reviewLightbox) return;
    reviewLightbox.classList.remove('open');
    setTimeout(function () { reviewLightbox.classList.add('hidden'); document.body.style.overflow = ''; }, 300);
  };

  window.closeReviewLightbox = function (e) {
    if (e && e.target.closest('.review-lightbox-content') && !e.target.closest('button') && !e.target.closest('a')) return;
    window.doCloseReviewLightbox();
  };

  /* Touch swipe for review lightbox */
  var rvTouchStartX = 0, rvTouchStartY = 0;
  var rvImgWrap = document.getElementById('reviewLightboxImgWrap');
  if (rvImgWrap) {
    rvImgWrap.addEventListener('touchstart', function (e) {
      rvTouchStartX = e.changedTouches[0].screenX;
      rvTouchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    rvImgWrap.addEventListener('touchend', function (e) {
      var diffX = rvTouchStartX - e.changedTouches[0].screenX;
      var diffY = rvTouchStartY - e.changedTouches[0].screenY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        diffX > 0 ? window.nextReviewLightbox() : window.prevReviewLightbox();
      } else if (diffY > 80) {
        window.doCloseReviewLightbox();
      }
    }, { passive: true });
  }

  /* ─── Keyboard Navigation ─── */
  document.addEventListener('keydown', function (e) {
    if (lightbox && lightbox.classList.contains('open')) {
      if (e.key === 'Escape') window.doCloseLightbox();
      if (e.key === 'ArrowRight') window.lightboxNext();
      if (e.key === 'ArrowLeft') window.lightboxPrev();
    }
    if (reviewLightbox && reviewLightbox.classList.contains('open')) {
      if (e.key === 'Escape') window.doCloseReviewLightbox();
      if (e.key === 'ArrowRight') window.nextReviewLightbox();
      if (e.key === 'ArrowLeft') window.prevReviewLightbox();
    }
  });

  /* ─── FAQ Toggle ─── */
  window.toggleFaq = function (btn) {
    var item = btn.closest('.faq-item');
    var content = item.querySelector('.faq-content');
    var allItems = document.querySelectorAll('.faq-item');
    allItems.forEach(function (i) {
      if (i !== item) {
        i.classList.remove('active');
        i.querySelector('.faq-content').classList.add('hidden');
      }
    });
    item.classList.toggle('active');
    content.classList.toggle('hidden');
  };

})();
